export const initialState = {
  appliedFilterData: {},
  currentFilterData: {},
  changesCount: 0,
  isChanged: false
};
